import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { createStyleHelper } from '../../../shared/utils/class-names';
import type { FCWithChildren } from '../../../shared/utils/component.interface';

import styles from './form-section.module.scss';

const style = createStyleHelper(styles, 'form-section');

export interface IFormSectionProps {
    title: string;
    description?: string;
    alwaysStacked?: boolean;
}

export const FormSection: FCWithChildren<IFormSectionProps> = ({
    title,
    description,
    children,
    alwaysStacked = false,
}) => {
    return (
        <fieldset className={style()}>
            <legend className={style('title')}>
                <FormattedMessage id={title} defaultMessage={title} />
            </legend>
            {description ? (
                <p className={style('description')}>
                    <FormattedMessage id={description} defaultMessage={description} />
                </p>
            ) : null}
            <div
                className={style('field-group', {
                    ['inline']: !alwaysStacked,
                })}
            >
                {children}
            </div>
        </fieldset>
    );
};
